import request from "@/utils/request";

//  获取用户信息
export function getEventUserInfo(eventId) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/user/queryUserInfo?eventId=${eventId}`,
    method: "get",
  });
}

// 更新用户信息
export function updateEventUserInfo(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/user/saveOrUpdateUserInfo`,
    method: "post",
    data,
  });
}

// 获取用户获奖信息
export function getEventUserAwardInfo(eventId) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/user/queryUserAwardInfo?eventId=${eventId}`,
    method: "get",
  });
}

// 领队获取用户获奖信息
export function getEventUserAwardInfoByLeader(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/user/queryAllUserAwardInfo`,
    method: "POST",
    data,
  });
}
